import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import axios from 'axios'

import Vuebar from 'vuebar';
Vue.use(Vuebar);

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2)

// ads
import Ads from 'vue-google-adsense'
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

import VueProgressiveImage from 'vue-progressive-image'

Vue.use(VueProgressiveImage)

import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

Vue.component('vue-draggable-resizable', VueDraggableResizable)

// Vue-disqus
import VueDisqus from 'vue-disqus'
Vue.use(VueDisqus)

// Utilities
import Storage from './utils/storage'
import MapHelpers from './utils/maphelpers'
Vue.use(Storage)
Vue.use(MapHelpers)


Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
